//首页banner

import React, { createRef } from "react";

import { Button, Carousel, Col, Row } from "antd";

import { graphql, navigate, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { useI18n } from "@src/i18n";
import * as styles from "./index.module.css";

const mobileButtonStyle = {
  position: "absolute",
  left: "50%",
  width: "180px",
  height: "40px",
  padding: "0 20px",
  transform: "translateX(-50%)",
  backgroundColor: "#0075FF",
  whiteSpace: "nowrap",
};

const Banner = () => {
  const { locale, t } = useI18n();
  const data = useStaticQuery(graphql`
    query {
      banner1: file(relativePath: { eq: "banner1.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1902) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      banner1En: file(relativePath: { eq: "banner1-en.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1902) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      banner2: file(relativePath: { eq: "banner2.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1902) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      banner2En: file(relativePath: { eq: "banner2-en.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1902) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      banner3: file(relativePath: { eq: "banner3.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1902) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      banner3En: file(relativePath: { eq: "banner3-en.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1902) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      banner4: file(relativePath: { eq: "banner4.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1902) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      banner4En: file(relativePath: { eq: "banner4-en.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1902) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  let bannerBox = createRef();
  const handleRegister = (event) => {
    event.preventDefault();
    navigate("/register/");
  };
  return (
    <div className={styles.bigBannerBox}>
      <Row>
        {/* pc端 */}
        <Col md={24} xs={0} sm={0} className={styles.innerBannerbox}>
          <Carousel
            ref={bannerBox}
            autoplay
            pauseOnDotsHover
            pauseOnFocus
            pauseOnHover
          >
            <div className={styles.bannerContainer}>
              <Img
                fluid={
                  locale === "en-US"
                    ? data.banner1En.childImageSharp.fluid
                    : data.banner1.childImageSharp.fluid
                }
                alt="Gatsby Docs are awesome"
              />
              <Button
                type="primary"
                className={styles.button}
                style={{
                  width: "195px",
                  height: "60px",
                  position: "absolute",
                  bottom: "25%",
                  fontSize: "16px",
                  backgroundColor:"#0075FF"
                }}
                shape="round"
                onClick={handleRegister}
              >
                {t("common.freeTrial")}
              </Button>
            </div>
            <div className={styles.bannerContainer}>
              <Img
                fluid={
                  locale === "en-US"
                    ? data.banner2En.childImageSharp.fluid
                    : data.banner2.childImageSharp.fluid
                }
                alt="Gatsby Docs are awesome"
              />
                <Button
                  type="primary"
                  className={styles.button}
                  style={{
                    width: "195px",
                    height: "60px",
                    position: "absolute",
                    fontSize: "16px",
                    backgroundColor:"#0075FF"
                  }}
                  shape="round"
                  onClick={handleRegister}
                >
                  {t("common.freeTrial")}
                </Button>
            </div>
          </Carousel>
        </Col>
        {/* 移动端 */}

        <Col md={0} xs={24} sm={24}>
          <Carousel autoplay pauseOnHover>
            <div className={styles.bannerContainer}>
              <Img
                fluid={
                  locale === "en-US"
                    ? data.banner3En.childImageSharp.fluid
                    : data.banner3.childImageSharp.fluid
                }
                alt="Gatsby Docs are awesome"
              />
                <Button
                  type="primary"
                  className={styles.mobileButton}
                  style={{
                    ...mobileButtonStyle,
                    bottom: "55%",
                  }}
                  shape="round"
                  onClick={handleRegister}
                >
                  {t("common.freeTrial")}
                </Button>
            </div>
            <div className={styles.bannerContainer}>
              <Img
                fluid={
                  locale === "en-US"
                    ? data.banner4En.childImageSharp.fluid
                    : data.banner4.childImageSharp.fluid
                }
                alt="Gatsby Docs are awesome"
              />
                <Button
                  type="primary"
                  className={styles.mobileButton}
                  style={{
                    ...mobileButtonStyle,
                    bottom: "55%",
                  }}
                  shape="round"
                  onClick={handleRegister}
                >
                  {t("common.freeTrial")}
                </Button>
            </div>
          </Carousel>
        </Col>
      </Row>
    </div>
  );
};
export default Banner;
